/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Apikey_Label1Inputs */

const id_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API`)
};

const ms_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API`)
};

const da_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Nøgle`)
};

const de_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel`)
};

const en_us2_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const es_es2_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave de API`)
};

const es_mx2_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const fil_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const fr_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé API`)
};

const it_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave API`)
};

const hu_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs`)
};

const nl_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel`)
};

const no_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkel`)
};

const pl_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klucz API`)
};

const pt_br2_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const pt_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave de API`)
};

const ro_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheie API`)
};

const fi_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avain`)
};

const sv_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckel`)
};

const vi_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khóa API`)
};

const tr_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Anahtarı`)
};

const cs_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API klíč`)
};

const bg_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API ключ`)
};

const ru_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ`)
};

const uk_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ`)
};

const ar_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مفتاح API`)
};

const hi_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी`)
};

const th_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คีย์ API`)
};

const ja_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キー`)
};

const zh_cn2_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const zh_hant1_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

const ko_notifications_apikey_label1 = /** @type {(inputs: Notifications_Apikey_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key`)
};

/**
* | output |
* | --- |
* | "API Key" |
*
* @param {Notifications_Apikey_Label1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_apikey_label1 = /** @type {((inputs?: Notifications_Apikey_Label1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Apikey_Label1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_apikey_label1(inputs)
	if (locale === "ms") return ms_notifications_apikey_label1(inputs)
	if (locale === "da") return da_notifications_apikey_label1(inputs)
	if (locale === "de") return de_notifications_apikey_label1(inputs)
	if (locale === "en-US") return en_us2_notifications_apikey_label1(inputs)
	if (locale === "es-ES") return es_es2_notifications_apikey_label1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_apikey_label1(inputs)
	if (locale === "fil") return fil_notifications_apikey_label1(inputs)
	if (locale === "fr") return fr_notifications_apikey_label1(inputs)
	if (locale === "it") return it_notifications_apikey_label1(inputs)
	if (locale === "hu") return hu_notifications_apikey_label1(inputs)
	if (locale === "nl") return nl_notifications_apikey_label1(inputs)
	if (locale === "no") return no_notifications_apikey_label1(inputs)
	if (locale === "pl") return pl_notifications_apikey_label1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_apikey_label1(inputs)
	if (locale === "pt") return pt_notifications_apikey_label1(inputs)
	if (locale === "ro") return ro_notifications_apikey_label1(inputs)
	if (locale === "fi") return fi_notifications_apikey_label1(inputs)
	if (locale === "sv") return sv_notifications_apikey_label1(inputs)
	if (locale === "vi") return vi_notifications_apikey_label1(inputs)
	if (locale === "tr") return tr_notifications_apikey_label1(inputs)
	if (locale === "cs") return cs_notifications_apikey_label1(inputs)
	if (locale === "bg") return bg_notifications_apikey_label1(inputs)
	if (locale === "ru") return ru_notifications_apikey_label1(inputs)
	if (locale === "uk") return uk_notifications_apikey_label1(inputs)
	if (locale === "ar") return ar_notifications_apikey_label1(inputs)
	if (locale === "hi") return hi_notifications_apikey_label1(inputs)
	if (locale === "th") return th_notifications_apikey_label1(inputs)
	if (locale === "ja") return ja_notifications_apikey_label1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_apikey_label1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_apikey_label1(inputs)
	return ko_notifications_apikey_label1(inputs)
});
export { notifications_apikey_label1 as "notifications.apiKey.label" }